import React, { useState, useRef, useEffect } from 'react';
import { HelpCircle } from 'lucide-react';
import theme from '../theme';

/**
 * Reusable inline help component.
 *   <HelpTip title="Primary-Sale Kickback Contribution" content="..." />
 * Renders a small ? icon that opens a compact popover on hover (desktop)
 * or click/tap (mobile). Positioned relative to the trigger.
 */
const HelpTip = ({ title, content, testId }) => {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    if (!open) return;
    const handler = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, [open]);

  return (
    <span
      ref={ref}
      style={{ position: 'relative', display: 'inline-flex', alignItems: 'center' }}
      onMouseEnter={() => setOpen(true)}
      onMouseLeave={() => setOpen(false)}
    >
      <button
        type="button"
        data-testid={testId || 'helptip-btn'}
        onClick={(e) => { e.preventDefault(); setOpen((v) => !v); }}
        aria-label={`Help: ${title || ''}`}
        style={{
          background: 'transparent',
          border: 'none',
          padding: 0,
          margin: 0,
          cursor: 'pointer',
          display: 'inline-flex',
          alignItems: 'center',
          color: theme.colors.text.secondary,
        }}
      >
        <HelpCircle size={14} />
      </button>
      {open && (
        <div
          data-testid={testId ? `${testId}-popover` : 'helptip-popover'}
          style={{
            position: 'absolute',
            top: '22px',
            left: '-8px',
            zIndex: 40,
            width: '280px',
            padding: '12px 14px',
            background: '#FFFFFF',
            border: `1px solid ${theme.colors.borders}`,
            borderRadius: theme.radius.sm,
            boxShadow: theme.colors.shadows?.lg || '0 6px 18px rgba(0,0,0,0.10)',
            fontSize: 12.5,
            lineHeight: 1.55,
            color: theme.colors.text.primary,
          }}
        >
          {title && (
            <div style={{ fontWeight: 700, marginBottom: 6, color: theme.colors.text.primary }}>
              {title}
            </div>
          )}
          <div style={{ color: theme.colors.text.secondary }}>{content}</div>
        </div>
      )}
    </span>
  );
};

export default HelpTip;
